module.exports = __webpack_public_path__ + "media/images/flextab-logo-text@2x-fdc8e82200de50d17f12d6d416fa8b3c.png";